const Brand = {
    NME: {
        text: 'A glimpse of NME’s exclusive product and service providers across the GCC and Middle East region...',
        type: 'text',
    },
    TEUFELBESCHLAG: {
        logo: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/brands%2FTeufelbeschlag.svg?alt=media&token=897a917e-8b6a-4781-a170-9eff7bf6cae6',
        link: 'http://www.teufelbeschlag.com/',
        type: 'link',
    },
    BELUTEC: {
        logo: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/brands%2FBeluTec.svg?alt=media&token=ecf4a588-df64-4ae3-8460-a1c1a382c333',
        link: 'http://www.belutec.com/',
        type: 'link',
    },
    CERO: {
        logo: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/brands%2Fcero.svg?alt=media&token=5de58951-4768-4c94-8d42-7ea751e0485e',
        link: 'http://cero.de/en/',
        type: 'link',
    },
    KUFFNER: {
        logo: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/brands%2Fkuffner.svg?alt=media&token=2f4a806d-b839-4360-b4aa-3df129dccf1e',
        link: 'http://kueffner.de/',
        type: 'link',
    },
    LACEFENCE: {
        logo: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/brands%2FLaceFence.svg?alt=media&token=0bc2a3b5-3c27-47a0-88c2-5ff4e6806f71',
        link: 'http://lacefence.com/ENG/index.php',
        type: 'link',
    },
    MWE: {
        logo: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/brands%2FMWE.svg?alt=media&token=b8befe80-c295-4edd-815e-05e7237a6e61',
        link: 'http://www.mwe.de/en/',
        type: 'link',
    },
    DEDOTS: {
        logo: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/brands%2Fdedots.svg?alt=media&token=4510ea6c-dcc0-45c8-b4ea-c0d676da2b70',
        link: 'http://dedots.world/',
        type: 'link',
    },
    SOLARLUX: {
        logo: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/brands%2Fsolarlux.svg?alt=media&token=f6d6d332-4f3a-410b-8069-6a2d8aa4118b',
        link: 'http://www.solarlux.com',
        type: 'link',
    },
    WOODWORKS: {
        logo: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/brands%2FWoodWorks.svg?alt=media&token=7ff44b98-d509-45f4-b22e-4d384ec3b77b',
        type: 'gallery',
    },
    SILBER: {
        logo: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/brands%2Fsilber.svg?alt=media&token=55be0aa1-007c-4354-847f-5561aaef7b85',
        link: 'http://www.silberfenster.at/en/doors/',
        type: 'link',
    },
    RECORD: {
        logo: 'https://firebasestorage.googleapis.com/v0/b/nme-website.appspot.com/o/brands%2Frecord.svg?alt=media&token=86389697-9bcd-4cbe-9c21-a38996013da7',
        link: 'https://www.record.global',
        type: 'link',
    },
};

export default Brand;



// WEBPACK FOOTER //
// ./src/data/brand.js